<template>
    <form class="banner-form form-horizontal"  @submit.prevent="submit()">
        <input type="hidden" id="color_fondo" v-model="data.color_fondo">
        <input type="hidden" id="color_fuente" v-model="data.color_fuente">
         <div  class="form-group">
            <label for="" class="col-sm-2 control-label">Texto banner</label>
                <div class="col-sm-10">
                    <editor-texto-banner v-model="textoeditor" :colorfont="data.color_fuente" > </editor-texto-banner>
                </div>
        </div>
       
        <div class="form-group"  :class="{'has-error': errors['esquema']}">
            <label for="url"  class="col-sm-2 control-label">Esquema color</label>
            <div class="col-sm-10">
                <el-select v-model="data.themeid" placeholder="Seleccione esquema"  id="esquema" @change="changeTheme">
                    <el-option
                        v-for="item in themes"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
                <div class="help-block" v-for="e in errors['esquema']">{{e}}</div>
            </div>
        </div>
        <div class="form-group"    >
            <label for="activo" class="col-sm-2 control-label">¿Activo?</label>
            <div class="col-sm-10">
                <el-switch  v-model="data.activo"  on-text="SI" off-text="NO"></el-switch>
            </div>
        </div>
        <div class="form-group">
            <label class="col-sm-2 control-label">Previsualización</label>
            <div class="col-sm-offset-2 col-sm-10">
                <div class="row"  >
                    <div  v-bind:style="{ 'background-color': data.color_fondo  }"  style="position: inherit;">
                        <div class="container">
                            <div class="collapse navbar-collapse link-coronavirus"  style="width: 60%;">
                                 <br>
                                    <span v-html="data.content" v-bind:style="{ 'color': data.color_fuente   }"  style="margin-bottom: 25px; margin-top: 25px;"></span>
                                    <br>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
         <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" href="backend/sections-home">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>
<script>
import ElementUI from 'element-ui';
import ElSwitch from 'element-ui/lib/switch';
import { Message } from "element-ui";
import ElSelect from 'element-ui/lib/select';
import ElOption from 'element-ui/lib/option';
import EditorTextoBanner from './EditorTextoBanner.vue';


export default {
    
    data:function(){
        var data =[];
        var banner = _.cloneDeep(this.banner);
      
        var textoeditor= banner.content;
        var textovisual=banner.content;

        textoeditor = textoeditor.replace(new RegExp(banner.color_fuente,"gi"), 'black');
 
        return{
            data:banner,
            textoeditor:textoeditor,          
            esquema: banner.themeid ,
            errors: {}
        }
    },
    props:['banner','themes'],
    components:{
        ElSwitch,
        ElSelect,
        ElOption,
        EditorTextoBanner
    },
    watch:{
        textoeditor: function(t){
            this.textoeditor = t;
            this.data.content = t.replace(/black/gi, this.data.backgroud_font);
            
        }
    },
    methods:{

        submit:function(){
            var self = this;
            var errores = {};
            var textnegrilla = '';
            var negrilla = false
            var textosimple = '';
            var simple = false;
    
            if(_.size(errores)>0){
                self.errores = errores;
                self.$message.error(
                  "Revise los errores en el formulario para continuar."
                );
                return false;
            }
    
            axios({
                url:"backend/sections-home/banner",
                method:"PUT",
                data: this.data
            }).then(function(response){
                window.location.replace(response.data.redirect);
            }).catch(function(error){
                self.errors = error.response.data.errors;
            });
        },
        changeTheme:function(id){
          
            var op = this.themes.find(t => t.id === id );
            var content =this.data.content; 

            content = content.replace(new RegExp(this.data.color_fuente,"gi"), op.backgroud_font);
            this.data.content = content;
            this.data.color_fondo= op.backgroud_color;    
            this.data.color_fuente = op.backgroud_font;
        }
    }
}
</script>